var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"child-flex":""}},[_c('v-card',[_c('v-card-title',[_vm._v("About")]),_c('v-card-text',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_vm._v(" Version: "+_vm._s(_vm.version)+" ")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }